	let mogineUrl =  '/mogine/'
	
	const productList= [
		{ text: 'navOptions.product.MoStudio', 		name: 'wecome',		path: '/wecome' },
		{ text: 'navOptions.product.MoIdeaAI',	name: 'MoAi',		path: '/MoAI' },
		{ text: 'navOptions.product.MogineLab',	name: 'lab',		path: '/lab/index' },
		{ text: 'navOptions.product.MoHuman',		name: 'aiHuman',		path: '/digitalHuman' },
	]
	const resoures = [
		{ text: 'navOptions.resoures.list', path: "#/list", domain: 'mogine' },
		{ text: 'navOptions.resoures.hotList', path: "#/hotList", domain: 'mogine' },
		{ text: 'navOptions.resoures.works', path: "#/works", domain: 'mogine' }
	]
	const works = [
		{ text: 'SketchUp', path: "" },
		{ text: '3ds Max', 	path: "" },
		{ text: 'Rhino', 	path: "" },
		{ text: 'Revit', 	path: "" },
		{ text: 'Archicad', path: "" },
		{ text: 'Cinema 4D', path: "" },
	]
	
	const server = [
		{ text: 'navOptions.server.jiejuefangan' },
		{ text: 'navOptions.server.chenggonganli' },
		{ text: 'navOptions.server.lianxiwomen', path: '/serve' },
		{ text: 'navOptions.server.guanyuwomen', path: '/about_us' },
	]
	
	const about = [
		{ text: 'navOptions.about.jingzhengyoushi' },
		{ text: 'navOptions.about.zuixingzixun', path: '/news' }
	]
	
	export {
		productList, resoures, works, mogineUrl, server, about
	}